import script from "./recipe-list.vue?vue&type=script&setup=true&lang=js"
export * from "./recipe-list.vue?vue&type=script&setup=true&lang=js"

import "./recipe-list.vue?vue&type=style&index=0&id=c856fd3c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c856fd3c"]])

export default __exports__